import React from 'react';

var Item = function Item(_ref) {
  var id = _ref.id,
      title = _ref.title;
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "#" + id
  }, title));
};

Item.displayName = 'Page Navigation Item';
export default Item;